import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { FcdProvider, FcdVersion } from 'app/models';
import { environment } from 'environments/environment';

import { HttpService } from './http.service';

const fcdProvidersUrl = `${environment.apiUrl}/fcdproviders`;
const fcdMapVersionUrl = `${environment.apiUrl}/fcdprovider/mapVersion`;
const fcdVersionsUrl = `${environment.apiUrl}/fcdversions`;

@Injectable()
export class FcdProviderService {
  constructor(private readonly httpService: HttpService) {}

  getFcdProviders(): Observable<FcdProvider[]> {
    return this.httpService.get<FcdProvider[]>(fcdProvidersUrl);
  }

  checkMapVersion(fcdVersion: FcdVersion): Observable<any> {
    const url = `${fcdMapVersionUrl}?mapId=${fcdVersion.mapId}`;
    return this.httpService.get<any>(url);
  }

  getFcdVersions(): Observable<FcdVersion[]> {
    return this.httpService.get<FcdVersion[]>(fcdVersionsUrl);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/fcdprovider.service.ts